import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { MentorState, MentorStateDescriptions } from '../../../models/enums/enums';
import { MentorService } from '../../../services/account/mentor.service';
import { AutoCompleteCompleteEvent, AutoCompleteModule } from 'primeng/autocomplete';
import { UtilityService } from '../../../services/utility/utility.service';
import { OlaPlacesResponse } from '../../../models/country/olaPlacesResponse';
import { InputNumberModule } from 'primeng/inputnumber';
import { countryResponse } from '../../../models/country/countryResponse';
import { SearchByNameResponse } from '../../../models/account/searchByNameResponse';
import { AdminState } from '../../../models/enums/adminState';
interface Status {
  name: string;
  value: number;
}
interface place {
  name: string
}


@Component({
  selector: 'app-mentors-search-filter',
  standalone: true,
  imports: [ReactiveFormsModule,FormsModule, CalendarModule, AutoCompleteModule,InputTextModule,InputNumberModule, DropdownModule, ButtonModule, CommonModule],
  templateUrl: './mentors-search-filter.component.html',
  styleUrls: ['./mentors-search-filter.component.scss']
})
export class MentorsSearchFilterComponent implements OnInit {
  
  submitted: boolean = false;
  filterForm!: FormGroup;
  places: place[] = [];
  names:SearchByNameResponse[] = []
  statuses = [
    { name: MentorStateDescriptions[MentorState.Unknown], value: 0 },
    { name: MentorStateDescriptions[MentorState.Active], value: 1 },
    { name: MentorStateDescriptions[MentorState.Inactive], value: 2 }
  ];
  years: { name: string; value: string }[] = [];
  months: { name: string; value: string }[] = [];
  countries: countryResponse[] = [];

  @Input() isSearching: boolean = false;
  @Input() isOperations: boolean = false;
  @Output() onSearch = new EventEmitter();

  constructor(private fb: FormBuilder, private mentorService: MentorService,
    private utilityService: UtilityService
  ) { }

  ngOnInit() {
    this.filterForm = this.fb.group({
      name:[null],
      companyOrSchool: [null],
      totalExperience:this.fb.group({
        years: [null],
        months: [null],
      }),
      nationality:[null],
      fromDate: [null],
      toDate: [null],
      email: [null, Validators.email],
      status: [{value: this.isOperations ? 1 : null, disabled: this.isOperations}]
    });
    this.setYearsOptions();
    this.setMonthsOptions();
    this.loadCountries();
  }

  private loadCountries(): void {
    this.utilityService.getCountries().subscribe({
      next: (response) => {
        if (response?.result) {
          this.countries = response.result;
        }
      },
      error: (err) => console.warn('Error loading countries:', err),
    });
  }
  

  setMonthsOptions() {
    this.months = Array.from({ length: 13 }, (_, i) => ({
      name: i.toString().padStart(2, '0'), // Use '00' to '12' format
      value: i.toString() // Values from 0 to 12 (no padding)
    }));
  }

  setYearsOptions() {
    this.years = Array.from({ length: 40 }, (_, i) => ({
      name: i.toString(), // Convert year to string for display (1 to 40)
      value: i.toString() // Use this as the actual value (1 to 40)
    }));
  }
  

  filterNames(event: AutoCompleteCompleteEvent) {
    if (event.query.length > 2) {
      this.utilityService.searchNamesByRole({
        roleName: 'Mentor',
        searchText: event.query
      }).subscribe({
        next: (response) => {
          this.names = response.result
        }
      });
    } else {
      this.names = [];
    }
  }

  filterPlaces(event: AutoCompleteCompleteEvent) {
    if (event.query.length > 3) {
      this.utilityService.getOLAPlaces(event.query).subscribe({
        next: (response: OlaPlacesResponse) => this.places = response.predictions.map(item => ({ name: item.description })),
      });
    } else {
      this.places = [{ name: event.query }];
    }
  }
  

  Search() {
    this.onSearch.emit(this.filterForm.value);
  }
}
